import { extractHeadings, type DocPageWithContent } from '@/services/docs';
import DocsArticle from './DocsArticle';
import DocsToc from './DocsToc';

interface DocsGroupPageProps {
  page: DocPageWithContent | undefined;
}

/** Shared article page for every group: header, body, and table of contents. */
export function DocsGroupPage({ page }: DocsGroupPageProps) {
  if (!page) {
    return (
      <div className="flex items-center justify-center p-20">
        <div className="text-center">
          <h1 className="text-copy-primary mb-2 text-2xl font-bold">Page Not Found</h1>
          <p className="text-copy-secondary">
            The documentation page you're looking for doesn't exist.
          </p>
        </div>
      </div>
    );
  }

  const headings = extractHeadings(page.content);

  return (
    <div className="docs-page-layout">
      <div className="docs-page-content">
        <header className="docs-page-header">
          <h1 className="docs-page-title">{page.title}</h1>
          {page.description && (
            <p className="docs-page-description">{page.description}</p>
          )}
        </header>
        <DocsArticle content={page.content} />
      </div>
      <DocsToc key={`${page.group}/${page.section}/${page.slug}`} headings={headings} />
    </div>
  );
}

export function DocsGroupPageLoading() {
  return (
    <div className="docs-page-layout">
      <div className="docs-page-content">
        <header className="docs-page-header">
          <div className="bg-surface-secondary h-10 w-1/2 animate-pulse rounded" />
          <div className="bg-surface-secondary mt-4 h-6 w-2/3 animate-pulse rounded" />
        </header>
      </div>
    </div>
  );
}

export default DocsGroupPage;
